import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { detailBuildEmployer } from "../../actions/employerAction";
import {
  applyBuildDeveloper,
  detailDeveloper,
} from "../../actions/developerAction";
import DevWelcome from "../../components/DevWelcome";
import DevMenu from "../../components/DevMenu";
import RightDash from "../../components/RightDash";
import Signout from "../../components/Signout";
import Message from "../../components/Message";

const DeveloperJob = ({ match, history, resizeMenu, setResizeMenu }) => {
  const id = match.params.id;

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const detailBuild = useSelector((state) => state.detailBuild);

  const { loading, job, error } = detailBuild;

  const applyBuild = useSelector((state) => state.developerApplyBuild);

  const {
    loading: applyBuildLoading,
    success,
    error: applyBuildError,
  } = applyBuild;

  const developerDetail = useSelector((state) => state.developerDetail);

  const { devDetail } = developerDetail;

  useEffect(() => {
    dispatch(detailBuildEmployer(id));
  }, [detailBuildEmployer]);

  useEffect(() => {
    dispatch(detailDeveloper());
  }, [detailDeveloper]);

  const handleClick = (e) => {
    e.preventDefault();
    dispatch(applyBuildDeveloper(id, history));
    // dispatch(detailBuildEmployer(id));
    // history.push("/developer/dashboard")
  };

  let alreadyApplied = "";

  if (job && Object.keys(job).length) {
    alreadyApplied = job.devapplied.some(
      (d) => d.user._id.toString() === userInfo._id.toString()
    );
  }

  console.log(alreadyApplied);

  return (
    <div className="dashboard">
      <DevMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {applyBuildError && (
          <Message variant="danger">{applyBuildError}</Message>
        )}

        {!devDetail && (
          <Message variant="danger">
            Fill your profile to apply for jobs
          </Message>
        )}
        {/* {success && (
          <Message variant="success">Application successful</Message>
        )} */}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <div className="right-wrapper">
            <DevWelcome />
            <div className="main p-3">
              <div>
                <h4 className="font-medium mb-2 d-flex align-items-center">
                  {job.title}
                  {devDetail && (
                    <button
                      onClick={handleClick}
                      className="ml-1 font-normal apply-btn rounded-sm px-1"
                      disabled={alreadyApplied}>
                      {alreadyApplied ? "Applied" : "Apply"}
                    </button>
                  )}
                  {applyBuildLoading && <div className="spinner-blue"></div>}
                </h4>
                <div>
                  <span className="font-weight-bolder">Description</span>
                  <p className="break">
                    {job.details}.{" "}
                    {job.file && job.file.length ? (
                      <span className="font-weight-bolder">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={job.file}>
                          <svg
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            width="20"
                            xmlns="http://www.w3.org/2000/svg"
                            className="vertical-middle">
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              class="jsx-2762790255"></path>
                          </svg>
                          <span class="jsx-2762790255">view document</span>
                        </a>{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Skills required:</span>{" "}
                    {job.skill && job.skill.join(", ")}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Budget(USD):</span> $
                    {job.budget}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Status:</span> {"   "}
                    {job.status}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default DeveloperJob;
